exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.remove-relation[data-v-2a727ec2] {\n    margin-right: 20px;\n}\n", ""]);

// exports
